import '@redq/reuse-modal/es/index.css';
import 'animate.css';
import {ResetCSS} from 'common/assets/css/style';
import {DrawerProvider} from 'common/contexts/DrawerContext';
import {theme} from 'common/theme/instagram';
import Seo from 'components/seo';
import AnalyticsTool from 'containers/Lp/AnalyticsTool/instagram';
import Banner from 'containers/Lp/Banner/instagram';
import Clients from 'containers/Lp/Clients';
import Footer from 'containers/Lp/Footer';
import HowItWorks from 'containers/Lp/HowItWorks';
import Navbar from 'containers/Lp/Navbar';
import Pricing from 'containers/Lp/Pricing';
import Contact from 'containers/Lp/ContactUs';
import Faq from 'containers/Lp/Faq';
import TwitterSection from 'containers/Lp/TwitterSection';
import FeaturesSecond from 'containers/Lp/FeatureSecond';
import {ContentWrapper, GlobalStyle} from 'containers/Lp/instagram.style';
import React, {Fragment} from 'react';
import Sticky from 'react-stickynode';
import {ThemeProvider} from 'styled-components';
import Like from 'containers/Lp/Like';
import Follow from 'containers/Lp/Follow';
const SaasAppCreative = () => {
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Seo title="Instagramのフォロワーが増えるAI自動アプリ | Autolikes【オートライクス】"
             description="インスタグラムのいいね・フォローを自動化し、フォロワーを増やすのに絶大な効果を発揮するアプリです。今だけ全機能を1ヶ月無料。"
             metaDescription="インスタグラムのいいね・フォローを自動化し、フォロワーを増やすのに絶大な効果を発揮するアプリです。今だけ全機能を1ヶ月無料。"
             keywords={["自動いいね","自動フォロー","フォロワーを増やす"]}
             link="/"
             meta={{name: "robots", content:"follow noindex"}}
        />

        <ResetCSS />
        <GlobalStyle />
        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <Banner />
          <HowItWorks />
          <Follow />
          <Like />
          <Clients />
          <AnalyticsTool />
          <FeaturesSecond />
          <TwitterSection />
          <Pricing />
          <Faq />
          <Contact />
          <Footer />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
};
export default SaasAppCreative;
